export default __webpack_public_path__ + "static/media/dnv-right.e8c66e3d.png";